import { Navigate, RouteObject } from "react-router-dom"
import BalanceList from "@/pages/TransactionRecordPage/subPages/BalanceList"
import BonusList from "@/pages/TransactionRecordPage/subPages/BonusList"
import DepositList from "@/pages/TransactionRecordPage/subPages/DepositList"
import WithdrawList from "@/pages/TransactionRecordPage/subPages/WithdrawList"

export const transactionRecordRoutes: RouteObject[] = [
    {
        index: true,
        element: (
            <Navigate
                to="balance"
                replace
            />
        ),
    },
    {
        path: "balance",
        element: <BalanceList />,
    },
    {
        path: "deposit",
        element: <DepositList />,
    },
    {
        path: "withdraw",
        element: <WithdrawList />,
    },
    {
        path: "bonus",
        element: <BonusList />,
    },
]
